"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.myObject = exports.myFunction = void 0;
var myFunction_1 = require("./myFunction");
Object.defineProperty(exports, "myFunction", { enumerable: true, get: function () { return myFunction_1.myFunction; } });
var myObject_1 = require("./myObject");
Object.defineProperty(exports, "myObject", { enumerable: true, get: function () { return myObject_1.myObject; } });
//# sourceMappingURL=index.js.map